module.exports = __webpack_public_path__ + "img/right-arm.5c1e022a.svg";